import Icon from '@klv/atoms/icon';
import Image from '@klv/atoms/image';

import * as styles from '../styles/tile.module.css';

import type { IImageOnly } from '../types';

const ImageOnly = ({
  backgroundColor,
  ctaVariant,
  hoverColor,
  image,
  link,
  mainTileHoverColor,
  tertiaryButtonText,
  openInNewTab,
}: IImageOnly) => (
  <div
    className={styles.imageOnlyContainer}
    data-background-color={backgroundColor}
    data-hover-color={hoverColor || mainTileHoverColor}
  >
    <a
      className={styles.tileLink}
      aria-label={openInNewTab ? `${image.altText} (opens in a new tab)` : ''}
      href={link}
      target={openInNewTab ? '_blank' : '_self'}
    >
      <div
        className={styles.imageOnlyContentContainer}
        data-cta-variant={ctaVariant}
      >
        {image && image?.gatsbyImage && (
          <div className={styles.imageContainer} data-cta-variant={ctaVariant}>
            <Image
              className={styles.styledImage}
              altText={image?.altText}
              imageData={image.gatsbyImage}
            />
          </div>
        )}
        {ctaVariant === 'tertiary button' ? (
          <div className={styles.styledButton}>{tertiaryButtonText}</div>
        ) : (
          <div className={styles.iconContainer}>
            <Icon fillColor='inherit' size={2.4} iconName='ArrowButtonRight' />
          </div>
        )}{' '}
      </div>
    </a>
  </div>
);

export default ImageOnly;
